import { z } from 'zod'

import noLeadingSpaces from '../../../../../utilities/noLeadingSpaces'

const passerror =
  'Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character, with a minimum length of eight characters, and must not contain any spaces.'
const MAX_FILE_SIZE = 5000000
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png']
export const formSchema = z.object({
  first_name: z
    .string({
      invalid_type_error: 'Required',
      required_error: 'Required',
    })
    .min(1, { message: 'Required' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
  last_name: z
    .string({
      invalid_type_error: 'Required',
      required_error: 'Required',
    })
    .min(1, { message: 'Required' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
  job_title: z.string().optional(),
  // contact_number: z
  //   .string({ required_error: 'Required' })
  //   .min(1, { message: 'Required' })
  //   .refine((value) => value === '' || /^(\+?\d{10,12})$/.test(value), {
  //     message: 'Invalid phone number.',
  //   })
  //   .refine(noLeadingSpaces, {
  //     message: 'Leading spaces are not allowed',
  //   }),
  contact_number: z
    .string()
    .refine(
      (value) =>
        value === '' ||
        /^(\+?\d{1,4}[\s-]?)?(\d{10}|\d{3}[\s-]?\d{3}[\s-]?\d{4}|\d{4}[\s-]?\d{3}[\s-]?\d{3})$/.test(
          value
        ),
      {
        message: 'Invalid phone number.',
      }
    )
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
  email: z
    .string({ required_error: 'Required' })
    .superRefine((value, ctx) => {
      if (value !== '') {
        if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Invalid email format.',
          })
        }
      }
    })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
  // password: z
  //   .string()
  //   .regex(new RegExp(/^[^\s]*$/), { message: 'Space not allowed' })
  //   .regex(new RegExp('.*[A-Z].*'), { message: text })
  //   .regex(new RegExp('.*[a-z].*'), { message: text })
  //   .regex(new RegExp('.*\\d.*'), { message: text })
  //   .regex(new RegExp('.*[`~<>?,./!@#$%^&*()\\-_+="\'|{}\\[\\];:\\\\].*'), {
  //     message: text,
  //   })
  //   .min(8, { message: text })
  //   .optional(),
  password: z
    .string()
    .optional()
    .refine((val) => /^[^\s]*$/.test(val as string), {
      message: 'Space not allowed',
    })
    .refine((val) => !val || /^[^\s]*$/.test(val), { message: passerror })
    .refine((val) => !val || /.*[A-Z].*/.test(val), { message: passerror })
    .refine((val) => !val || /.*[a-z].*/.test(val), { message: passerror })
    .refine((val) => !val || /.*\d.*/.test(val), { message: passerror })
    .refine(
      (val) => !val || /.*[`~<>?,./!@#$%^&*()\-_=+"'\|{}\[\];:\\].*/.test(val),
      { message: passerror }
    )
    .refine((val) => !val || val.length >= 8, { message: passerror }),
  status: z
    .string({
      invalid_type_error: 'Required',
      required_error: 'Required',
    })
    .min(1, { message: 'Required' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),
  status_id: z.string().optional().nullable(),
  profile_image: z
    .union([z.instanceof(File), z.any()])
    .refine((file) => !(file instanceof File) || file.size <= MAX_FILE_SIZE, {
      message: 'Maximum size 5mb',
    })
    .refine(
      (file) =>
        !(file instanceof File) || ACCEPTED_IMAGE_TYPES.includes(file.type),
      {
        message: 'File type not allowed',
      }
    )
    .nullable(),
  // .optional(),
})

export type OrgUserSchema = z.infer<typeof formSchema>
